import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { USER_FEATURE_KEY } from './keys';
import { userReducer } from './reducers/user.reducer';
import { UserEffects } from './effects/user.effects';
import { User_LibraryBridge } from './bridges/user_library.bridge';
import { User_ProgressBridge } from './bridges/user_progress.bridge';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(USER_FEATURE_KEY, userReducer),
        EffectsModule.forFeature([UserEffects, User_LibraryBridge, User_ProgressBridge]),
    ],
})
export class UserStoreModule {}
